import React from 'react'
import styled from 'styled-components'
import { StyledBrandingButton } from '../MoveForm/MoveForm.style'

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: #f5f7fa;
  text-align: center;
  padding: 16px;

  @media screen and (max-width: 480px) {
    align-items: flex-start;
  }
`

const StyledBtnContainer = styled.div`
  align-items: center;
  width: 100%;
`
const StyledText = styled.p`
  font-size: 22px;
  color: #262626;
  margin-bottom: 15px;

  @media screen and (max-width: 1024px) {
    text-align: left;
    font-size: 22px;
  }
`

const StyledTitle = styled.h3`
  font-size: 24px;
  color: #262626;
  font-weight: normal;

  @media screen and (max-width: 1024px) {
    font-size: 22px;
    text-align: left;
  }
`
const FormReminder = ({ isLogicImmo }) => {
  const content = (
    <StyledContainer>
      <StyledTitle isLogicImmo={isLogicImmo}>
        Avez-vous trouvé votre <strong>nid douillet ? </strong>
      </StyledTitle>
      <StyledText isLogicImmo={isLogicImmo}>Commencez à préparer votre déménagement dès aujourd’hui</StyledText>
      <StyledBtnContainer>
        <StyledBrandingButton
          onClick={() => {
            document.getElementById('form-section').scrollIntoView({ behavior: 'smooth' })
          }}
          tag="button"
          size="lg"
          appearence="filled"
          format="normal"
          style={{ width: '266px' }}
        >
          Obtenir mon estimation
        </StyledBrandingButton>
      </StyledBtnContainer>
    </StyledContainer>
  )

  return content
}

export default FormReminder
